angular.module('common.model.measuretype', ['ngResource', 'common.helper']).factory('MeasureType', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/meae/measureTypes', {}, {
        queryMeasureTypes: {
            method: 'GET',
            isArray: false
        },
        queryMeasureTypesSecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/ref/meae/measureTypes'
        }

    });
}).service('MeasureTypeModel', function (MeasureType, $q, CommonHelper, AuthorizeModel) {
    var model = this;

    model.getMeasureTypes = function (tradeDirection, startDate, endDate) {
        var deferred = $q.defer();
        if (AuthorizeModel.loggedIn) {
            MeasureType.queryMeasureTypesSecure({
                startDate: CommonHelper.getRestDateString(startDate),
                endDate: CommonHelper.getRestDateString(endDate),
                tradeDirection: tradeDirection === 'I' || tradeDirection === 'E' ? tradeDirection : null,
                filterHiddenMeasureTypes: false
            }, function (result) {
                deferred.resolve(result);
            }, function (error) {
                // Use unauthenticated query
                MeasureType.queryMeasureTypes({
                    startDate: CommonHelper.getRestDateString(startDate),
                    endDate: CommonHelper.getRestDateString(endDate),
                    tradeDirection: tradeDirection === 'I' || tradeDirection === 'E' ? tradeDirection : null
                }, function (result) {
                    deferred.resolve(result);
                }, function (error) {
                    deferred.reject(error);
                });
            });
        } else {
            MeasureType.queryMeasureTypes({
                startDate: CommonHelper.getRestDateString(startDate),
                endDate: CommonHelper.getRestDateString(endDate),
                tradeDirection: tradeDirection === 'I' || tradeDirection === 'E' ? tradeDirection : null
            }, function (result) {
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
        }

        return deferred.promise;
    };
});



// WEBPACK FOOTER //
// ./app/common/model/taric/measure-type-model.js